module.exports = __webpack_public_path__ + "img/0040.a2a9a46d.png";